import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "vehicle-report-grid-card" }
const _hoisted_3 = { class: "vehicle-report-grid-title" }
const _hoisted_4 = {
  id: "detailsModal",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_5 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "modal-header" }
const _hoisted_8 = { class: "modal-title" }
const _hoisted_9 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ExportButtons, {
          csv: _ctx.exportGridsToExcel,
          pdf: _ctx.exportGridsToPdf,
          xlsx: _ctx.exportGridsToExcel
        }, null, 8, ["csv", "pdf", "xlsx"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('components.reports.statistics.statistics')), 1),
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.dataGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            class: "vehicle-report-grid",
            "data-source": _ctx.store,
            "hover-state-enabled": true,
            "remote-operations": _ctx.remoteOperations,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: false }),
              _createVNode(_component_DxPaging, {
                "page-index": 0,
                "page-size": 25
              }),
              _createVNode(_component_DxPager, {
                "allowed-page-sizes": [10, 20, 25],
                "show-info": true,
                "show-navigation-buttons": true,
                "show-page-size-selector": true
              }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: true }),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.reports.statistics.registrationOrName'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "registration_or_name"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.reports.statistics.distance'),
                "filter-operations": _ctx.allowedOperations,
                "data-field": "distance"
              }, null, 8, ["caption", "filter-operations"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": true,
                "allow-header-filtering": false,
                caption: _ctx.$t('components.reports.statistics.ignition'),
                "filter-operations": _ctx.allowedOperations,
                "customize-text": _ctx.formatMinutesCell,
                "data-field": "ignition"
              }, null, 8, ["caption", "filter-operations", "customize-text"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.reports.statistics.details'),
                type: "buttons"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxButton, {
                    hint: _ctx.$t('components.reports.statistics.details'),
                    icon: "detailslayout",
                    onClick: _ctx.displayDetails
                  }, null, 8, ["hint", "onClick"])
                ]),
                _: 1
              }, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "remote-operations"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$t('components.reports.statistics.details')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("button", {
                    "aria-label": "Close",
                    class: "btn-close",
                    "data-bs-dismiss": "modal",
                    type: "button"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ExportButtons, {
                    csv: _ctx.exportGridsToExcel,
                    details: true,
                    pdf: _ctx.exportGridsToPdf,
                    xlsx: _ctx.exportGridsToExcel
                  }, null, 8, ["csv", "pdf", "xlsx"]),
                  _createVNode(_component_DxDataGrid, {
                    ref: _ctx.dataGridRefDetails,
                    "allow-column-reordering": true,
                    "allow-column-resizing": true,
                    "column-auto-width": true,
                    "data-source": _ctx.detailsStore,
                    "hover-state-enabled": true,
                    "remote-operations": false,
                    "row-alternation-enabled": true,
                    "show-borders": true,
                    "show-column-lines": true,
                    "show-row-lines": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxHeaderFilter, { visible: false }),
                      _createVNode(_component_DxPaging, {
                        "page-index": 0,
                        "page-size": 25
                      }),
                      _createVNode(_component_DxPager, {
                        "allowed-page-sizes": [10, 20, 25],
                        "show-info": true,
                        "show-navigation-buttons": true,
                        "show-page-size-selector": true
                      }),
                      _createVNode(_component_DxFilterRow, { visible: true }),
                      _createVNode(_component_DxColumnFixing, { enabled: true }),
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        caption: _ctx.$t('components.reports.statistics.date'),
                        "filter-operations": _ctx.allowedOperations,
                        "customize-text": _ctx.formatDateCell,
                        "data-field": "date_from"
                      }, null, 8, ["caption", "filter-operations", "customize-text"]),
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        caption: _ctx.$t('components.reports.statistics.distance'),
                        "filter-operations": _ctx.allowedOperations,
                        "data-field": "distance"
                      }, null, 8, ["caption", "filter-operations"]),
                      _createVNode(_component_DxColumn, {
                        "allow-filtering": true,
                        "allow-header-filtering": false,
                        caption: _ctx.$t('components.reports.statistics.ignition'),
                        "filter-operations": _ctx.allowedOperations,
                        "customize-text": _ctx.formatMinutesCell,
                        "data-field": "ignition"
                      }, null, 8, ["caption", "filter-operations", "customize-text"])
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ])
              ])
            ])
          ])
        ])
      ]))
}